/**
 * @author        julian@zumper.com (Julian Napolitan)
 * @copyright     Copyright (c) 2020, Zumper
 * @description   ContactContainer
 */

import { LIST_ITEM_CALL } from '@zcode-ui/web-zumper-integrations'
import { Origin } from '@zcode/nr-utils'
import { trackOptimizelyPhoneEvents } from '@zcode/nr/es/shared/thirdParty/optimizely/thunks'
import { hocCompose, memoMapDispatchToProps, withErrorBoundary } from '@zcode/react-utils'
import type { State } from '@zcode/state-type'
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import { getMessaged } from '../../../../../inspectors/index'
import { mixpanelCall } from '../../../../../modules/mixpanel/thunks/mixpanelCall'
import { trackListItemEvent } from '../../../../../modules/traktor/thunks/trackListItemEvent'
import { trackCallEvent } from '../../../../../utils/trackCallEvent'
import { getRecentLeadCounts } from '../../../../message/MessageForm/helpers/getShouldLimitLeads'
import { Contact, type Props } from './Contact'

const mapStateToProps = (state: State) => {
  const messaged = getMessaged(state)
  const { longTermLeadCount, shortTermLeadCount } = getRecentLeadCounts(messaged)
  return {
    longTermLeadCount,
    shortTermLeadCount,
  }
}

const mapDispatchToProps = (dispatch: Dispatch, ownProps: Pick<Props, 'entity'>) => {
  return {
    onPaidPhoneClick: (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation()
      const { entity } = ownProps

      trackCallEvent(entity)
      dispatch(trackListItemEvent({ name: LIST_ITEM_CALL, entity }))
      dispatch(trackOptimizelyPhoneEvents({ entity }))
      dispatch(mixpanelCall({ entity, origin: Origin.LISTABLES }))
    },
  }
}

const shallowEqualProps = ['entity' as const]
const memoMapContactDispatchToProps = memoMapDispatchToProps(
  mapDispatchToProps,
  undefined,
  shallowEqualProps
)

const ContactContainer = hocCompose(
  connect(mapStateToProps, memoMapContactDispatchToProps),
  withErrorBoundary({ displayName: 'ContactContainer' }),
  Contact
)

export { ContactContainer }
